import { render } from "./Password.vue?vue&type=template&id=48fe1be0&scoped=true"
import script from "./Password.vue?vue&type=script&lang=js"
export * from "./Password.vue?vue&type=script&lang=js"

import "./Password.vue?vue&type=style&index=0&id=48fe1be0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-48fe1be0"

export default script